export const b2bLocale = [
  'en',
  'ko',
  'es',
  'fr',
  'pt',
  'it',
  'de',
  'ru',
  'he',
  'ar',
  'zh_CN',
  'zh_TW',
  'vi',
  'cs',
  'pl',
  'bg',
  'ro',
  'tr',
  'th',
  'ja'
];

export const smsMaxLength: { [key: string]: number } = {
  en: 126,
  ko: 73,
  es: 130,
  fr: 135,
  pt: 130,
  it: 140,
  de: 140,
  ru: 70,
  he: 140,
  ar: 140,
  zh_CN: 140,
  zh_TW: 140,
  vi: 140,
  cs: 140,
  pl: 140,
  bg: 140,
  ro: 140,
  tr: 140,
  th: 140,
  ja: 140
};
